import { InviewAnim } from "./inviewport";

export const OurQualities = () => {
    const qualitiesData = [
        {
            label: 'QUALITY ASSURED',
            icon: '/svgs/shield.svg',
            text: 'Carefully inspected vehicles for your peace of mind.'
        },
        {
            label: 'COMPETITIVE PRICES',
            icon: '/svgs/price-tag.svg',
            text: 'Best market prices with excelent value.'
        },
        {
            label: 'FAST IMPORT PROCESS',
            icon: '/svgs/cargo-ship.svg',
            text: 'Efficient shipping and smooth customs clearance.'
        },
        {
            label: 'NATIONWIDE DELIVERY',
            icon: '/svgs/delivery.svg',
            text: 'We deliver to all regions across Cameroon.'
        }
    ]
    return (
        <div className="qualities-container">
            {qualitiesData.map((data) => (
                <InviewAnim
                    inView={'after-slide-up'}
                    notInView={'before-slide-up'}
                >
                    <div className="quality-unit">
                        <img src={data.icon} alt="" className="q-image" />
                        <span className="q-label hd">{data.label}</span>
                        <span className="q-text">{data.text}</span>
                    </div>
                </InviewAnim>
            ))}
        </div>
    );
}